import { render } from "./AdminRegister.vue?vue&type=template&id=7f08ffc0&scoped=true"
import script from "./AdminRegister.vue?vue&type=script&lang=js"
export * from "./AdminRegister.vue?vue&type=script&lang=js"

import "./AdminRegister.vue?vue&type=style&index=0&id=7f08ffc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f08ffc0"]])

export default __exports__